<p-toast id="success-toast" position="bottom-right" [preventOpenDuplicates]="true"></p-toast>

<p-toast id="error-toast" position="center" key="error-toast" [preventOpenDuplicates]="true">
    <ng-template let-message pTemplate="message">
        <div class="p-d-flex p-flex-column">
            <div class="p-text-center">
				<i class="pi pi-exclamation-triangle"></i>
				
                <h4>{{message.summary}}</h4>
                <p>{{message.detail}}</p>
			</div>
			
            <button type="button" pButton (click)="onCloseError()" label="Close" class="p-button-danger"></button>
        </div>
    </ng-template>
</p-toast>

<p-toast id="system-toast" position="top-right" key="system-toast">
    <ng-template pTemplate="message" let-message>
        <div class="p-d-flex p-flex-column p-ai-center p-jc-center w-100">
            <div class="p-d-flex p-jc-between p-ai-center w-100">
                <i [class]="Icons.INFO_CIRCLE"></i>
                <h4 class="p-ml-2" style="flex-grow: 1">{{message.summary}}</h4>
            </div>
            <div *ngIf="isSystemNotificationMessage(message) as message" class="p-d-flex p-ai-start p-jc-center">
                <button pButton label="View" (click)="message.action()"></button>
            </div>
        </div>
    </ng-template>
</p-toast>